import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vector',
  templateUrl: './vector.component.html',
  styleUrls: ['./vector.component.scss']
})
export class VectorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
